module.exports = __webpack_public_path__ + "static/media/secret-mobile.8aed3121.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/winter-2019/secret-mobile.png
// module id = 176
// module chunks = 0